import { render, staticRenderFns } from "./EmergencyPersonnel.vue?vue&type=template&id=2e193148&scoped=true&"
import script from "./EmergencyPersonnel.vue?vue&type=script&lang=js&"
export * from "./EmergencyPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyPersonnel.vue?vue&type=style&index=0&id=2e193148&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e193148",
  null
  
)

export default component.exports